import { render, staticRenderFns } from "./ImpersonationBlockedModal.vue?vue&type=template&id=3c205b24&scoped=true"
import script from "./ImpersonationBlockedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonationBlockedModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImpersonationBlockedModal.vue?vue&type=style&index=0&id=3c205b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c205b24",
  null
  
)

export default component.exports